import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=872d21e2"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"
import style0 from "./Report.vue?vue&type=style&index=0&id=872d21e2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('872d21e2')) {
      api.createRecord('872d21e2', component.options)
    } else {
      api.reload('872d21e2', component.options)
    }
    module.hot.accept("./Report.vue?vue&type=template&id=872d21e2", function () {
      api.rerender('872d21e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Report/Report.vue"
export default component.exports